import { render, staticRenderFns } from "./ExtendSession.vue?vue&type=template&id=596f56f7"
import script from "./ExtendSession.vue?vue&type=script&lang=js"
export * from "./ExtendSession.vue?vue&type=script&lang=js"
import style0 from "./ExtendSession.vue?vue&type=style&index=0&id=596f56f7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports